// import moment from "moment";
import moment from "moment-timezone";

interface DayTiming {
    timings: string;
}

type WeeklySchedule = Record<string, DayTiming>;

export const getDay = (date?:any) => {
    const currentDate = date ? new Date(date) : new Date();
    const dayOfWeek = currentDate?.getDay();
    const daysOfWeek = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    const currentDay = daysOfWeek[dayOfWeek];
    return currentDay;
}

// export const checkIfOpenUsingHoursandScheduledTime = (openFrom: string, openTo: string, scheduleTime: string) => {
//     const openingTime = new Date(`${new Date().toISOString().split('T')[0]}T${openFrom}Z`);
//     const closingTime = new Date(`${new Date().toISOString().split('T')[0]}T${openTo}Z`);
//     const currentTimeDate = new Date(`${new Date().toISOString().split('T')[0]}T${scheduleTime}Z`);
//     if (closingTime < openingTime) {
//         closingTime.setDate(closingTime.getDate() + 1);
//     }
//     return (currentTimeDate >= openingTime && currentTimeDate <= closingTime);
// };

export const checkIfOpenUsingHoursandScheduledTime = (openFrom: string, openTo: string, scheduleTime: string) => {
    const today = moment.utc().format("YYYY-MM-DD");

    const openingTime = moment.utc(`${today} ${openFrom}`, "YYYY-MM-DD HH:mm:ss");
    let closingTime = moment.utc(`${today} ${openTo}`, "YYYY-MM-DD HH:mm:ss");
    let currentTimeDate = moment.utc(`${today} ${scheduleTime}`, "YYYY-MM-DD HH:mm:ss");

    // If closing time is before opening time, it's an overnight schedule
    if (closingTime.isBefore(openingTime)) {
        closingTime.add(1, "day");
    }

    // If the current time is before opening and the store opens before closing, shift currentTimeDate
    if (currentTimeDate.isBefore(openingTime) && closingTime.isAfter(openingTime)) {
        currentTimeDate.add(1, "day");
    }

    return currentTimeDate.isBetween(openingTime, closingTime, undefined, "[]"); // Inclusive range
};

export const checkIfOpenUsingHours = (openFrom: string, openTo: string) => {
    const now = new Date();
    const dateString = now.toISOString().split('T')[0]; 

    const openingTime = new Date(`${dateString}T${openFrom}Z`);
    let closingTime = new Date(`${dateString}T${openTo}Z`);
    let currentTimeUTC = new Date(now.toISOString()); 

    if (closingTime <= openingTime) {
        closingTime.setUTCDate(closingTime.getUTCDate() + 1);
    }
    
    if (currentTimeUTC < openingTime && currentTimeUTC < closingTime && openTo < openFrom) {
        openingTime.setUTCDate(openingTime.getUTCDate() - 1);
        closingTime.setUTCDate(closingTime.getUTCDate() - 1);
    }

    const isOpen = currentTimeUTC >= openingTime && currentTimeUTC < closingTime;

    return isOpen;
};

export const isClosed = (organizationSettings: any, organizationOrdersOpenSchedule: any) => {
    const daySettings = organizationOrdersOpenSchedule ? organizationOrdersOpenSchedule[getDay()]: null;
    if(organizationSettings){
        if(organizationSettings?.ordersHolidays?.some(
            (holiday: any) =>
              moment(holiday.holidayDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
          )){
            return true;
        } 
        else if(!organizationSettings?.enableOrders){
            return true;
        }
        else if(daySettings?.closedAllDay){
            return true;
        }
        else if(daySettings?.openAllDay === false && daySettings?.closedAllDay === false){
            return !checkIfOpenUsingHours(daySettings?.openFrom, daySettings?.openTo)
        }
        else{
            return false
        }
    }
    return false;
}

export const isOpenHoursClosed = (organizationSettings: any, organizationOrdersOpenSchedule: any) => {
    const daySettings = organizationOrdersOpenSchedule ? organizationOrdersOpenSchedule[getDay()]: null;
    if(organizationSettings){
        if(organizationSettings?.ordersHolidays?.some(
            (holiday: any) =>
              moment(holiday.holidayDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
          )){
            return true;
        } 
        else if(daySettings?.closedAllDay){
            return true;
        }
        else if(daySettings?.openAllDay === false && daySettings?.closedAllDay === false){
            return !checkIfOpenUsingHours(daySettings?.openFrom, daySettings?.openTo)
        }
        else{
            return false
        }
    }
    return false;
}

export const roundToNext15Min = (date:any) => {
    // const remainder = 15 - date.minute() % 15;
    // if (remainder !== 15) {
    //     date.add(remainder, 'minutes'); // Only add remainder if it's not already on a 15 minute interval
    // }
    // return date;
    let m = moment(date);
    let minutes = m.minutes();   
    if (minutes >= 0 && minutes < 10) {
        m.minutes(15);
    } else if (minutes >= 10 && minutes < 25) {
        m.minutes(30);
    } else if (minutes >= 25 && minutes < 40) {
        m.minutes(45);
    } else if (minutes >= 40 && minutes < 55) {
        m.add(1, 'hour').minutes(0);
    } else if (minutes >= 55) {
        m.add(1, 'hour').minutes(15);
    }      
    return m;
}

export const roundToNext30Min = (date: any) => {
    const m = moment(date);
    const minutes = m.minutes();

    if (minutes <= 28) {
        m.minutes(30);
    } else {
        m.add(1, "hour").minutes(0);
    }

    return m.seconds(0).milliseconds(0);
};

export const getWeeklySchedule = (organizationOrdersOpenSchedule:any) => {
    
    const days: (keyof any)[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const schedule: WeeklySchedule = {};
    if (!organizationOrdersOpenSchedule) {
        return schedule;
    }
    days.forEach((day:any) => {
        const daySettings = organizationOrdersOpenSchedule[day];
        const openFrom = `${new Date().toISOString().split('T')[0]}T${daySettings?.openFrom}Z`;
        const openTo = `${new Date().toISOString().split('T')[0]}T${daySettings?.openTo}Z`;
        if (daySettings?.closedAllDay) {
            schedule[day] = { timings: "Closed" };
        } else if (daySettings?.openFrom && daySettings?.openTo) {
            schedule[day] = { timings: `${moment(new Date(openFrom)).format("h:mmA")}-${moment(new Date(openTo)).format("h:mmA")}`};
        }
        else{
            schedule[day] = { timings: "-" };
        }
    });
    return schedule;
};

export const getFormattedHolidays = (organizationSettings: any) => {
  if (!organizationSettings) return [];

  const holidays = organizationSettings?.ordersHolidays || [];  
  const TIMEZONE = moment.tz.guess();  

  return holidays.map((holiday: any) => {
   const utcMoment = moment.utc(holiday?.holidayDate);
   const dateOnly = utcMoment.format('YYYY-MM-DD');


    const makeLocal = (time: string) => {
      if (!time) return null;
      const timeStr = time.length === 5 ? `${time}:00` : time;
      const m = moment.tz(`${dateOnly} ${timeStr}`, 'YYYY-MM-DD HH:mm:ss', TIMEZONE);
      return m;
    };

    const startM = makeLocal(holiday?.openFrom);
    const endM = makeLocal(holiday?.openTo);

    const displayDateM = startM || moment.tz(dateOnly, 'YYYY-MM-DD', TIMEZONE);

    return {
      date: displayDateM.format('MMMM, DD YYYY'),
      day: displayDateM.format('dddd'),
      time:
        startM && endM
          ? `${startM.format('hh:mm A')} - ${endM.format('hh:mm A')}`
          : null,
    };
  });
};